import { useState, useEffect } from "react";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";
import {
  InventoryStockResponse,
  ItemNeeded,
  WarehouseItems,
} from "../../Interfaces/Warehouse";
import { useNavigate } from "react-router/dist";
import "./InventoryRemaining.css";

const InventoryRemaining = () => {
  const [skusNeeded, setSkusNeeded] = useState<ItemNeeded[]>([]);
  const [inventoryStock, setInventoryStock] = useState<
    InventoryStockResponse[]
  >([]);
  useEffect(() => {
    const fetchInventoryStock = async () => {
      try {
        const response = await fetchWithAuth(
          `${config.API_BASE_URL}inventory-stock/stock-counts/`,
        );

        if (response.status === 200) {
          const data = await response.json();
          setInventoryStock(data);
        } else {
          console.error("Failed to fetch inventory stock:", response.status);
        }
      } catch {
        console.log("Failed to fetch inventory stock");
      }
    };
    const fetchSkusNeeded = async () => {
      try {
        const response = await fetchWithAuth(
          `${config.API_BASE_URL}orders/warehouse/`,
        );
        if (response.status === 200) {
          const data: WarehouseItems = await response.json();
          setSkusNeeded(data.needed_skus);
        } else {
          console.error("Failed to fetch SKUs needed:", response.status);
        }
      } catch {
        console.log("Failed to fetch SKUs needed");
      }
    };

    fetchInventoryStock();
    fetchSkusNeeded();
    document.title = "MamFam Inventory Remaining";
  }, []);

  const navigate = useNavigate();
  const navigationButtons = [
    {
      label: "Inventory Stock",
      link: "/warehouse/inventory-stock",
    },
    {
      label: "Inventory Updates",
      link: "/warehouse/inventory-changes",
    },
    {
      label: "Pending Orders",
      link: "/warehouse/orders",
    },
  ];

  const getInventoryStock = (sku: string) => {
    return inventoryStock.find((stock) => stock.sku === parseInt(sku));
  };

  return (
    <div>
      <h1>Inventory Remaining</h1>
      {navigationButtons.map((button: { label: string; link: string }) => (
        <button onClick={() => navigate(button.link)}>{button.label}</button>
      ))}
      {skusNeeded.length > 0 && (
        <table className="warehouse-order-table">
          <thead>
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Quantity in Stock</th>
              <th>Quantity Needed</th>
              <th>Remaining</th>
            </tr>
          </thead>
          <tbody>
            {skusNeeded.map((item) => {
              const stock = getInventoryStock(item.sku);
              const quantityInStock = stock?.quantity || 0;
              const remaining = quantityInStock - item.quantity;

              return !item.is_custom ? (
                <tr
                  key={item.sku}
                  className={remaining <= 1 ? "low-stock" : ""}
                >
                  <td>{item.sku}</td>
                  <td>{item.product_name}</td>
                  <td>{quantityInStock}</td>
                  <td>{item.quantity}</td>
                  <td>{remaining}</td>
                </tr>
              ) : null;
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default InventoryRemaining;
